import { Box, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useForm } from "react-hook-form";
import { useNavigate, useParams } from 'react-router-dom';
import {
  useCreateAnnualConferenceMutation, useLazyGetAnnualConferenceByIdQuery,
  useUpdateAnnualConferenceMutation
} from '../../../app/services/annualConferenceService';
import { toast } from 'react-toastify';
import { selectCurrentScope, selectUserId } from "../../../app/auth/authSlice";
import { useSelector } from "react-redux";
import placeholder from "../../../assets/images/placeholder/placeholder.png"
import Spinner from "../../../Component/spinner/spinner";
import ImageCropModal, { useImageCrop } from '../../../Component/ImageCropModal/ImageCropModal';

const AddEditImportAnnualConference = () => {
  const [createAnnualConference] = useCreateAnnualConferenceMutation();
  const navigate = useNavigate();
  const { id } = useParams()
  const [getById] = useLazyGetAnnualConferenceByIdQuery();
  const [updateAnnualConference] = useUpdateAnnualConferenceMutation();
  const memberScope = useSelector(selectCurrentScope);
  const userId = useSelector(selectUserId);
  const [selectedDesktopImage, setSelectedDesktopImage] = useState();
  const [loading, setLoading] = useState(false);

  // Crop modal hook — output 2020×525 px
  const { cropModal, openCropModal, handleCropApply, closeCropModal } = useImageCrop();

  const onCropDone = (base64) => {
    setSelectedDesktopImage(base64);
    setValue("imageUrl", base64);
  };

  const {
    register,
    handleSubmit,
    setValue,
    reset,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: { conferenceName: '', venue: '', date: '', imageUrl: '', hostedBy: '' }
  });

  useEffect(() => {
    getById(id).then((res) => {
      if (res?.data?.status) {
        Object.entries(res?.data?.data).forEach(([key, value]) => {
          setValue(key, value)
        })
      }
    })
      .catch((err) => console.log(err))
  }, [id, setValue, getById])

  const onSaveConference = (data) => {
    setLoading(true);

    if (id) {
      const updateData = {
        id,
        data
      }
      const base64Regex =
        /^data:image\/(?:png|jpeg|jpg|gif);base64,[\w+/=]+$/;
      const uploadImg = data?.imageUrl;
      if (base64Regex.test(data?.imageUrl)) {
        data.imageUrl = uploadImg; // No change needed if it's base64
      } else {
        data.imageUrl = data.imageUrl
          .split("/")
          .slice(-2)
          .join("/");
      }
      updateAnnualConference(updateData).then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message)
          if (memberScope === "PORTAL_SUPER_ADMIN") {
            navigate("/admin/annualConferenceList");
          } else if (memberScope === "PORTAL_ADMIN") {
            navigate("/assistantadmin/annualConferenceList");
          }
        }
        else {
          toast.error(res?.data?.message)
        }
        setLoading(false);
      }).catch(err => console.log(err))
    }
    else {
      const newData = {
        ...data,
        createdBy: { id: userId, role: memberScope }
      }
      // Call the mutation to create the conference
      createAnnualConference(newData).then((res) => {
        if (res?.data?.status) {
          toast.success(res?.data?.message)
          if (memberScope === "PORTAL_SUPER_ADMIN") {
            navigate("/admin/annualConferenceList");
          } else if (memberScope === "PORTAL_ADMIN") {
            navigate("/assistantadmin/annualConferenceList");
          }
          reset()
        } else {
          toast.error(res?.data?.err?.message)
        }
        setLoading(false);

      })
        .catch(err => console.error(err))
    }

  };

  // Removed handleDesktopImageChange (using openCropModal instead)

  return (
    <div>
      <Box>
        <div className="pt-5">
          <div className="chapter-heading">
            <h2 className="text-center title-font text-light py-3 mt-1">{id ? "Edit Annual Conference " : "Add Annual Conference "}</h2>
          </div>
        </div>
        {loading ? <Spinner /> : (

          <form onSubmit={handleSubmit(onSaveConference)}>
            <div className='p-md-5 p-3 overallPadding' >
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
                <Button onClick={() => navigate(-1)} variant='contained' style={{ color: 'white', textTransform: "uppercase" }} className="menus-color">Back</Button>
              </Box>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={4}>
                  {id ? (
                    <>
                      <img
                        src={selectedDesktopImage
                          ? selectedDesktopImage
                          : watch("imageUrl")
                            ? watch("imageUrl")
                            : placeholder}
                        alt="Logo Preview"
                        height="150"
                        className="img-responsive w-100"
                      />
                      <label htmlFor="imageUrl" style={{ display: "none" }}>
                        <input
                          accept="image/jpeg, image/png"
                          id="imageUrl"
                          type="file"
                          style={{ display: "none" }}
                          onChange={(e) => openCropModal(e)}
                        />
                      </label>
                      <div className='d-flex justify-content-center'>
                        <Button
                          variant="contained menus-color text-colors"
                          component="span"
                          style={{ whiteSpace: "nowrap", fontFamily: 'poppins' }}
                          className="mt-2"
                          onClick={() => document.getElementById("imageUrl").click()}
                        >
                          Choose File
                        </Button>
                      </div>
                    </>
                  ) : (
                    <div className='d-flex flex-column align-items-center w-100 gap-2'>
                      {/* Image preview for Add mode */}
                      {(selectedDesktopImage || watch("imageUrl")) && (
                        <div className="d-flex justify-content-center w-100">
                          <img
                            src={selectedDesktopImage || watch("imageUrl")}
                            alt="Conference Img"
                            className="img-responsive w-100"
                            style={{ objectFit: "scale-down" }}
                          />
                        </div>
                      )}
                      <TextField
                        InputLabelProps={{ shrink: true }}
                        style={{ width: "100%" }}
                        inputProps={{ accept: "image/jpeg, image/png" }}
                        id="imageUrl"
                        label={
                          <Typography className="text-dark">
                            Image Url <span style={{ color: "red" }}>*</span>
                          </Typography>
                        }
                        variant="outlined"
                        type="file"
                        {...register("image", {
                          required: { value: !watch('imageUrl'), message: 'Please select an image' },
                          onChange: (e) => openCropModal(e),
                        })}
                        error={!!errors?.image}
                        helperText={errors?.image?.message}
                      />
                    </div>
                  )}

                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    id="conferenceName"
                    label={
                      <Typography className="text-dark">
                        Conference Name <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    placeholder="Enter Conference Name"
                    variant="outlined"
                    {...register("conferenceName", {
                      required: "Please enter a conference name",
                      minLength: { value: 3, message: "Conference name must be at least 3 characters long" }
                    })}
                    error={!!errors?.conferenceName}
                    helperText={errors?.conferenceName?.message}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    id="venue"
                    placeholder="Enter Venue"

                    label={
                      <Typography className="text-dark">
                        Venue <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    variant="outlined"
                    {...register("venue", {
                      required: "Please enter a venue",
                    })}
                    error={!!errors?.venue}
                    helperText={errors?.venue?.message}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    id="date"
                    label={
                      <Typography className="text-dark">
                        Date <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    placeholder="Enter Date"
                    variant="outlined"
                    {...register("date", {
                      required: "Please enter a date",
                    })}
                    error={!!errors?.date}
                    helperText={errors?.date?.message}
                  />
                </Grid>
                <Grid item xs={12} sm={4}>
                  <TextField
                    InputLabelProps={{ shrink: true }}
                    fullWidth
                    id="hostedBy"
                    label={
                      <Typography className="text-dark">
                        Hosted by <span style={{ color: "red" }}>*</span>
                      </Typography>
                    }
                    placeholder="Enter Hosted by"
                    variant="outlined"
                    {...register("hostedBy", {
                      required: "Please enter a host name",
                    })}
                    error={!!errors?.hostedBy}
                    helperText={errors?.hostedBy?.message}
                  />
                </Grid>


              </Grid>
              <Box sx={{ display: 'flex', justifyContent: 'center', padding: 3 }}>
                <Button variant='contained' type="submit" style={{ color: 'white', textTransform: "uppercase" }} className="menus-color">{id ? "Update" : "Submit"}</Button>
              </Box>
            </div>
          </form >
        )}
      </Box >
      {/* Image Crop Modal — crops to 2020×525 px */}
      <ImageCropModal
          open={cropModal.open}
          imageSrc={cropModal.src}
          onCancel={closeCropModal}
          onCrop={(base64) => handleCropApply(base64, onCropDone)}
          outputWidth={2020}
          outputHeight={525}
          title="Crop Annual Conference Image (2020 × 525 px)"
      />
    </div >
  );
};

export default AddEditImportAnnualConference;
